// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","396":"5ae14f32","455":"1b3c3dad","977":"670b9fab"}[chunkId] + ".chunk.js";
};